export default __webpack_public_path__ + "static/media/cover.4f57baf5.jpeg";